// 숫자 콤마 포맷
export const formatNumber = (num: number | null | undefined): string => {
  if (num === null || num === undefined) {
    return '0';
  }
  return num.toLocaleString('ko-KR');
};

// 금액 포맷
export const formatCurrency = (amount: number | null | undefined): string => {
  return `₩${formatNumber(amount)}`;
};

// YYYY-MM-DD 형식
export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// YYYY-MM-DD HH:mm:ss 형식
export const formatDateTime = (dateString: string): string => {
  const date = new Date(dateString);
  const dateStr = formatDate(dateString);
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${dateStr} ${hours}:${minutes}:${seconds}`;
};
